import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import RewardIcon from 'components/RewardIcon';
import { isExpired } from 'utils/rewards';
import CalendarIcon from 'resources/calendar_icon.png';
import RedCloseIcon from 'resources/red_close_icon.png';
import TreeBackground from 'resources/large_tree_pls.png';
import RewardCalendar from '../RewardCalendar';
import TreeGraphic from '../../GetMoreRewardsCard/assets/Miami graphic.png';
import './RewardCardModal.scss';

const PLS_PRIZE_TYPE = {
  AMOUNT_PRIZE_TYPE: 'amountPrizeType',
  VALUE_PRIZE_TYPE: 'valuePrizeType'
};

const RewardCardModal = ({ reward, show, closeModal, isRewardAvailable }) => {
  const [showCalendar, setShowCalendar] = useState(false);

  const getValueInfo = () => {
    const {
      allowsPartialRedemption,
      totalValue,
      remainingValue,
      usedValue,
      prizeType
    } = reward;
    const isPointsType = prizeType === PLS_PRIZE_TYPE.AMOUNT_PRIZE_TYPE;
    const isValueType = prizeType === PLS_PRIZE_TYPE.VALUE_PRIZE_TYPE;

    if (
      isExpired(reward) ||
      isPointsType ||
      (isValueType && !allowsPartialRedemption)
    ) {
      return (
        <div className="pls-redeem-info-container">
          <div className="total">
            <span className="title">Total </span>
            <span className="value">{totalValue}</span>
          </div>
        </div>
      );
    } else if (isValueType && allowsPartialRedemption) {
      return (
        <div className="pls-redeem-info-container">
          <div className="used">
            <span className="title">Used </span>
            <span className="value">{usedValue}</span>
          </div>
          <div className="remaining">
            <span className="title">Remaining </span>
            <span className="value">{remainingValue}</span>
          </div>
        </div>
      );
    }
  };

  return (
    <Modal className="reward-card-modal" show={show} onHide={closeModal}>
      <Modal.Body>
        <div className={`profile-reward-card`}>
          <img
            className="reward-card-tree-background"
            src={TreeBackground}
            alt=""
          />
          <img className="reward-card-tree-graphic" src={TreeGraphic} alt="" />
          <div className="reward-name">{reward.name}</div>
          <div className="reward-icon-image-container">
            <RewardIcon
              className="reward-icon-image"
              url={reward.url}
              type={reward.type}
              alt="reward icon"
              size={100}
            />
          </div>
          {getValueInfo()}
          {isRewardAvailable && (
            <>
              <button
                className="show-calendar-container"
                onClick={() => setShowCalendar(true)}
                type="button"
              >
                <img
                  className="reward-calendar-icon"
                  src={CalendarIcon}
                  alt="Reward Calendar"
                />
                <div className="show-calendar-text">See Dates and Times</div>
              </button>
              <RewardCalendar
                show={showCalendar}
                onClose={() => setShowCalendar(false)}
                validStartDate={reward.startDate}
                validEndDate={reward.endDate}
                blackoutDates={reward.blackoutDates}
                dailyValidFromTime={reward.dailyValidFromTime}
                dailyValidToTime={reward.dailyValidToTime}
              />
            </>
          )}
        </div>
        <button
          className="modal-close-button"
          onClick={closeModal}
          type="button"
        >
          <img src={RedCloseIcon} alt="Close Modal" />
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default RewardCardModal;
